import {Component, Input} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import { ActivatedRoute, Router, Params } from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-contactDepartment-detail',
  templateUrl: './contactDepartment-detail.component.html'
})
export class ContactDepartmentDetailComponent extends BaseComponent {
  contactCompanyId:any;
  contactDepartment:any;
  companyId:any;
  isCompanyAdmin: boolean;
  isContactCompanyLinked: boolean;
  isEmbedded:boolean;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              protected auth:AuthService,
              private route: ActivatedRoute,
              private router:Router,
              private alertService:AlertService) {
    super(env, http);
  }

  onInit() {
    this.isEmbedded = !!this.route.snapshot.queryParamMap.get('embedded');
    this.route.params
      .subscribe((params: Params) => {
        this.contactCompanyId = params['contactCompanyId'];
        this.companyId = params['companyId'];
        let id:any = params['id'];
        if (!this.auth.isCompanyAdmin()) {
          this.companyId = this.auth.getCompanyId();
        } else {
          this.isCompanyAdmin = true;
          this.companyId = this.companyId || this.auth.companyIdFilter;
        }

        if (id === '0') {
          this.isContactCompanyLinked = !!this.contactCompanyId;
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/auth/contactDepartments/${id}`).subscribe(
            data => {
              this.contactDepartment = data;
              this.contactCompanyId = this.contactDepartment.contactCompanyId;
              this.companyId = this.contactDepartment.companyId;
            }
          );
        }
      });
  }

  createNew() {
    this.contactDepartment = {
      companyId: this.companyId,
      contactCompanyId: this.isContactCompanyLinked ? this.contactCompanyId : undefined
    };
  }

  deleteContactDepartment() {
    this.http.delete(`${this.env.e.url}/auth/contactDepartments/${this.contactDepartment.id}`).subscribe(
      complete => {
        this.router.navigate([`/contactCompanies/${this.contactCompanyId}`]);
      }
    );
  }

  save() {
    if (this.contactDepartment.id) {
      this.http.put(`${this.env.e.url}/auth/contactDepartments/${this.contactDepartment.id}`, this.contactDepartment).subscribe(
        data => {
          this.contactDepartment = data;
          this.alertService.info(`Updated ${this.contactDepartment.name}`);
          if (this.isEmbedded)
            this.router.navigate([`/contactCompanies/${this.contactCompanyId}`]);
          else
            this.router.navigate([`/contactDepartments`]);
        }
      );
    } else {
      this.contactDepartment.contactCompanyId = this.contactCompanyId;
      this.http.post(`${this.env.e.url}/auth/contactDepartments`, this.contactDepartment).subscribe(
        data => {
          this.contactDepartment = data;
          this.alertService.info(`Created ${this.contactDepartment.name}`);
          if (this.isEmbedded)
            this.router.navigate([`/contactCompanies/${this.contactCompanyId}`]);
          else
            this.router.navigate([`/contactDepartments`]);
        }
      );
    }
  }
}
